import { EnqueueTypeId as EnqueueTypeId$1, DequeueTypeId as DequeueTypeId$1, QueueStrategyTypeId as QueueStrategyTypeId$1, isQueue as isQueue$1, isDequeue as isDequeue$1, isEnqueue as isEnqueue$1, backPressureStrategy as backPressureStrategy$1, droppingStrategy as droppingStrategy$1, slidingStrategy as slidingStrategy$1, make as make$1, bounded as bounded$1, dropping as dropping$1, sliding as sliding$1, unbounded as unbounded$1, capacity as capacity$1, size as size$1, isEmpty as isEmpty$1, isFull as isFull$1, isShutdown as isShutdown$1, awaitShutdown as awaitShutdown$1, shutdown as shutdown$1, offer as offer$1, unsafeOffer as unsafeOffer$1, offerAll as offerAll$1, poll as poll$1, take as take$1, takeAll as takeAll$1, takeUpTo as takeUpTo$1, takeBetween as takeBetween$1, takeN as takeN$1 } from '../../internal/queue.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const EnqueueTypeId = EnqueueTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const DequeueTypeId = DequeueTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const QueueStrategyTypeId = QueueStrategyTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * The base interface that all `Queue`s must implement.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * Returns `true` if the specified value is a `Queue`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isQueue = isQueue$1;

/**
 * Returns `true` if the specified value is a `Dequeue`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isDequeue = isDequeue$1;

/**
 * Returns `true` if the specified value is a `Enqueue`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isEnqueue = isEnqueue$1;

/**
 * @since 2.0.0
 * @category strategies
 */
const backPressureStrategy = backPressureStrategy$1;

/**
 * @since 2.0.0
 * @category strategies
 */
const droppingStrategy = droppingStrategy$1;

/**
 * @since 2.0.0
 * @category strategies
 */
const slidingStrategy = slidingStrategy$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Makes a new bounded `Queue`. When the capacity of the queue is reached, any
 * additional calls to `offer` will be suspended until there is more room in
 * the queue.
 *
 * **Note**: When possible use only power of 2 capacities; this will provide
 * better performance by utilising an optimised version of the underlying
 * `RingBuffer`.
 *
 * @since 2.0.0
 * @category constructors
 */
const bounded = bounded$1;

/**
 * Makes a new bounded `Queue` with the dropping strategy.
 *
 * When the capacity of the queue is reached, new elements will be dropped and the
 * old elements will remain.
 *
 * **Note**: When possible use only power of 2 capacities; this will provide
 * better performance by utilising an optimised version of the underlying
 * `RingBuffer`.
 *
 * @since 2.0.0
 * @category constructors
 */
const dropping = dropping$1;

/**
 * Makes a new bounded `Queue` with the sliding strategy.
 *
 * When the capacity of the queue is reached, new elements will be added and the
 * old elements will be dropped.
 *
 * **Note**: When possible use only power of 2 capacities; this will provide
 * better performance by utilising an optimised version of the underlying
 * `RingBuffer`.
 *
 * @since 2.0.0
 * @category constructors
 */
const sliding = sliding$1;

/**
 * Creates a new unbounded `Queue`.
 *
 * @since 2.0.0
 * @category constructors
 */
const unbounded = unbounded$1;

/**
 * Returns the number of elements the queue can hold.
 *
 * @since 2.0.0
 * @category getters
 */
const capacity = capacity$1;

/**
 * Retrieves the size of the queue, which is equal to the number of elements
 * in the queue. This may be negative if fibers are suspended waiting for
 * elements to be added to the queue.
 *
 * @since 2.0.0
 * @category getters
 */
const size = size$1;

/**
 * Returns `true` if the `Queue` contains zero elements, `false` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isEmpty = isEmpty$1;

/**
 * Returns `true` if the `Queue` contains at least one element, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const isFull = isFull$1;

/**
 * Returns `true` if `shutdown` has been called, otherwise returns `false`.
 *
 * @since 2.0.0
 * @category getters
 */
const isShutdown = isShutdown$1;

/**
 * Waits until the queue is shutdown. The `Effect` returned by this method will
 * not resume until the queue has been shutdown. If the queue is already
 * shutdown, the `Effect` will resume right away.
 *
 * @since 2.0.0
 * @category utils
 */
const awaitShutdown = awaitShutdown$1;

/**
 * Interrupts any fibers that are suspended on `offer` or `take`. Future calls
 * to `offer*` and `take*` will be interrupted immediately.
 *
 * @since 2.0.0
 * @category utils
 */
const shutdown = shutdown$1;

/**
 * Places one value in the queue.
 *
 * @since 2.0.0
 * @category utils
 */
const offer = offer$1;

/**
 * Places one value in the queue.
 *
 * @since 2.0.0
 * @category utils
 */
const unsafeOffer = unsafeOffer$1;

/**
 * For Bounded Queue: uses the `BackPressure` Strategy, places the values in
 * the queue and always returns true. If the queue has reached capacity, then
 * the fiber performing the `offerAll` will be suspended until there is room
 * in the queue.
 *
 * For Unbounded Queue: Places all values in the queue and returns true.
 *
 * For Sliding Queue: uses `Sliding` Strategy If there is room in the queue,
 * it places the values otherwise it removes the old elements and enqueues the
 * new ones. Always returns true.
 *
 * For Dropping Queue: uses `Dropping` Strategy, It places the values in the
 * queue but if there is no room it will not enqueue them and return false.
 *
 * @since 2.0.0
 * @category utils
 */
const offerAll = offerAll$1;

/**
 * Returns the first value in the `Queue` as a `Some<A>`, or `None` if the queue
 * is empty.
 *
 * @since 2.0.0
 * @category utils
 */
const poll = poll$1;

/**
 * Takes the oldest value in the queue. If the queue is empty, this will return
 * a computation that resumes when an item has been added to the queue.
 *
 * @since 2.0.0
 * @category utils
 */
const take = take$1;

/**
 * Takes all the values in the queue and returns the values. If the queue is
 * empty returns an empty collection.
 *
 * @since 2.0.0
 * @category utils
 */
const takeAll = takeAll$1;

/**
 * Takes up to max number of values from the queue.
 *
 * @since 2.0.0
 * @category utils
 */
const takeUpTo = takeUpTo$1;

/**
 * Takes a number of elements from the queue between the specified minimum and
 * maximum. If there are fewer than the minimum number of elements available,
 * suspends until at least the minimum number of elements have been collected.
 *
 * @since 2.0.0
 * @category utils
 */
const takeBetween = takeBetween$1;

/**
 * Takes the specified number of elements from the queue. If there are fewer
 * than the specified number of elements available, it suspends until they
 * become available.
 *
 * @since 2.0.0
 * @category utils
 */
const takeN = takeN$1;

export { DequeueTypeId, EnqueueTypeId, QueueStrategyTypeId, awaitShutdown, backPressureStrategy, bounded, capacity, dropping, droppingStrategy, isDequeue, isEmpty, isEnqueue, isFull, isQueue, isShutdown, make, offer, offerAll, poll, shutdown, size, sliding, slidingStrategy, take, takeAll, takeBetween, takeN, takeUpTo, unbounded, unsafeOffer };
